import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.exact({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      hash: PropTypes.string
    })
  ]).isRequired,
  children: PropTypes.node.isRequired
};

const LinkExternal = props => {
  const { to, children } = props;
  const args = Object.assign({}, props);
  let link;
  delete args.to;
  delete args.childern;
  delete args.target;
  delete args.rel;
  if (typeof to === 'string') {
    link = to;
  } else {
    const { pathname, search = '', hash = '' } = to;
    link = pathname + search + hash;
  }
  return (
    <a href={link} {...args} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

LinkExternal.propTypes = propTypes;

export default LinkExternal;
